/*
 * !!!!!
 * You MUST use full variable name (e.g. `import.meta.env.REACT_APP_VERSION`) to be able to override them at runtime!
 * This is a requirement of import-meta-env plugin: https://import-meta-env.org/guide/getting-started/introduction.html#syntax
 * !!!!
 */

export const sentryDsn = () => import.meta.env.REACT_APP_SENTRY_DSN!;

export const matomoUrl = () => import.meta.env.MATOMO_BASE_URL!;
export const matomoProjectId = () => import.meta.env.MATOMO_PROJECT_ID!;
export const matomoDisabled = () => toBoolean(import.meta.env.MATOMO_DISABLED);
/*
 * build.REACT_APP_VERSION is defined at build time (vite.config.ts)
 * you could override it with env. variable REACT_APP_VERSION if you'd like to
 */
export const buildVersion = build.REACT_APP_VERSION;
export const appVersion = () =>
  import.meta.env.REACT_APP_VERSION! || buildVersion;

export const FeatureFlags = {
  isMiniProfilerEnabled: () =>
    toBoolean(import.meta.env.REACT_APP_MINI_PROFILER_ENABLED),
  isNotificationTooltipEnabled: () =>
    toBoolean(import.meta.env.FEATURE_FLAG_WARRANTY_NOTIFICATION),
  isReferenceSearchEnabled: () =>
    toBoolean(import.meta.env.FEATURE_FLAG_WARRANTY_REFERENCE),
  isPageEditorAIEnabled: () =>
    toBoolean(import.meta.env.FEATURE_FLAG_PAGE_EDITOR_AI),
  isGlobalSearchEnabled: () =>
    toBoolean(import.meta.env.FEATURE_FLAG_GLOBAL_SEARCH),
  isNotificationsEnabled: () =>
    toBoolean(import.meta.env.FEATURE_FLAG_NOTIFICATIONS),
  isPageDesignerVersionsEnabled: () =>
    toBoolean(import.meta.env.FEATURE_FLAG_PAGE_DESIGNER_VERSIONS),
  isAzureAuthEnabled: () =>
    toBoolean(import.meta.env.FEATURE_FLAG_AZURE_AUTH_ENABLED) &&
    !FeatureFlags.isSupplierPortal(),
  umamiUrl: () => import.meta.env.REACT_APP_UMAMI_URL,
  umamiSiteId: () => import.meta.env.REACT_APP_UMAMI_SITE_ID,
  isUserActionsEnabled: () =>
    toBoolean(import.meta.env.FEATURE_FLAG_USER_ACTIONS_ENABLED),
  isAdvancedSearchEnabled: () =>
    toBoolean(import.meta.env.FEATURE_FLAG_ADVANCED_SEARCH_ENABLED),
  isMainboardReplacerEnabled: () =>
    toBoolean(import.meta.env.FEATURE_FLAG_MAINBOARD_REPLACER_ENABLED),
  isCreateRepairRequestEnabled: () =>
    toBoolean(import.meta.env.FEATURE_FLAG_CREATE_REPAIR_REQUEST_ENABLED),
  isPDFGeneratingEnabled: () =>
    toBoolean(import.meta.env.FEATURE_FLAG_PDF_GENERATING_ENABLED),
  isMarkAsSentEnabled: () =>
    toBoolean(import.meta.env.FEATURE_FLAG_MARK_AS_SENT_ENABLED),
  isWarningMessageEnabled: () =>
    toBoolean(import.meta.env.FEATURE_FLAG_WARNING_MESSAGE_ENABLED),
  warningMessageTranslationKey: () =>
    import.meta.env.FEATURE_FLAG_WARNING_MESSAGE_TRANSLATION_KEY,

  isSupplierPortal: () => document.location.hostname.includes('leosupply'),
  isTodayStage: () => document.location.hostname.includes('lmt-app.today'),
  isGreenStage: () => document.location.hostname.includes('lmt-app.green'),
  isCareStage: () => document.location.hostname.includes('lmt-app.care'),
  isProdStage: () =>
    document.location.hostname.includes('leoworld.loewensteinmedical.com'),
};

/*
 * This function converts 'false', '0', null, undefined to boolean `false`
 * Everything else is converted to boolean `true`.
 * (all default conversions like `!!value` or `Boolean(value)` do not convert 'false' to boolean false
 */
function toBoolean(value: string): boolean {
  if (!value) return false;
  const lowercaseValue = value.toLowerCase();
  if (lowercaseValue === 'false' || lowercaseValue === '0') return false;
  return true;
}
